<template>
    <el-card>
        <template #header>
            <content-header> 区域列表 </content-header>
        </template>

        <search-form ref="searchForm" :fields="search" />

        <el-table :data="areas" resource="area">
            <!--<el-table-column prop="id" label="ID" width="60"/>-->
            <el-table-column
                prop="name"
                label="区域名称"
                align="center"
                show-overflow-tooltip
                min-width="10%"
            />

            <el-table-column
                label="状态"
                align="center"
                show-overflow-tooltip
                min-width="5%"
            >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status" type="success">正常</el-tag>
                    <el-tag v-else type="danger">停用</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                v-if="this.is_administrator"
                label="所属商户"
                align="center"
                show-overflow-tooltip
                min-width="8%"
            >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.merchant_data" type="success">
                        {{ scope.row.merchant_data.name }}
                    </el-tag>
                    <el-tag v-else type="success">admin</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="服务时间"
                align="center"
                show-overflow-tooltip
                min-width="10%"
            >
                <template slot-scope="scope">
                    <el-tag>{{ scope.row.customer_service_time }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                prop="customer_service_phone"
                label="服务手机号"
                align="center"
                show-overflow-tooltip
                min-width="10%"
            />
            <el-table-column
                label="是否为克隆区域"
                align="center"
                show-overflow-tooltip
                min-width="10%"
            >
                <template slot-scope="scope">
                    <el-tag v-if="!scope.row.clone_id">否</el-tag>
                    <el-tag v-if="scope.row.clone_id" type="warning">是</el-tag>
                </template>
            </el-table-column>

            <el-table-column
                prop="created_at"
                label="添加时间"
                align="center"
                show-overflow-tooltip
                min-width="10%"
            />
            <el-table-column
                prop="updated_at"
                label="修改时间"
                align="center"
                show-overflow-tooltip
                min-width="10%"
            />
            <el-table-column label="操作" width="300">
                <template #default="{}">
                    <row-to-edit />
                    <row-destroy />
                    <row-add-parking>管理停车区</row-add-parking>
                </template>
            </el-table-column>
        </el-table>
        <div class="card-footer">
            <pagination :page="page" />
        </div>
    </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getAreas } from "@/api/area";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import RowAddParking from "./components/RowAddParking";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
    name: "Index",
    components: {
        RowToEdit,
        RowDestroy,
        SearchForm,
        Pagination,
        RowAddParking,
    },
    data() {
        return {
            search: [
                {
                    field: "id",
                    label: "ID",
                },
                {
                    field: "name",
                    label: "名称",
                },
            ],
            areas: [],
            page: null,
            first_blood: true,
            is_administrator: false,
        };
    },
    async created() {
        // const [{data: merchant}] = await Promise.all([
        //     getAdminUsersMerchant({all: 1}),
        // ])
        // this.search[2].options.push.apply(this.search[2].options, merchant.data)

        if (this.$store.state.users.user.roles[0] === "administrator") {
            const [{ data: merchant }] = await Promise.all([
                getAdminUsersMerchant({ all: 1 }),
            ]);
            if (env.isPosSwitch == true) {
                this.search.push({
                    type: "el-select",
                    field: "merchant_id",
                    label: "商户",
                    options: [
                        {
                            id: "",
                            name: "全部",
                        },
                    ],
                });
                this.search[2].options.push.apply(
                    this.search[2].options,
                    merchant.data
                );
            }
        }
    },
    mixins: [mixinsAutoPageSize],
    watch: {
        $route: {
            async handler(newVal) {
                await this.autoPageSize(53, newVal);
                const {
                    data: { data, meta },
                } = await getAreas(newVal.query);

                this.areas = data;
                this.page = meta;
                console.log(data, "888");
            },
            immediate: true,
        },
    },
};
</script>
